export default __webpack_public_path__ + "static/media/google icon.6db5c226.svg";